import httpService from '../../utils/httpService';
import authen from '../../utils/authen';

function unwrapResponse (res) {
  if (res == null) return null;
  if (typeof res === 'string') {
    try { return JSON.parse(res); } catch (e) { return null; }
  }
  if (typeof res === 'object' && res.data !== undefined && res.ok === undefined) return res.data;
  return res;
}

const emptyConfig = () => ({
  brokers: [],
  defaultMappings: {},
  devices: {}
});

export default {
  namespaced: true,
  state: {
    config: emptyConfig(),
    version: 0,
    updatedAt: 0,
    updatedBy: '',
    statuses: []
  },
  getters: {
    config: state => state.config,
    version: state => state.version,
    statuses: state => state.statuses,
    updatedBy: state => state.updatedBy
  },
  mutations: {
    SET_CONFIG (state, payload) {
      state.config = (payload && payload.config) || emptyConfig();
      state.version = (payload && payload.version) || 0;
      state.updatedAt = (payload && payload.updatedAt) || 0;
      state.updatedBy = (payload && payload.updatedBy) || '';
      state.statuses = (payload && payload.statuses) || [];
    }
  },
  actions: {
    FETCH_CONFIG ({ commit }) {
      return httpService.methods.$post('MqttIntegrationAPI/GetConfig', JSON.stringify({
        tokenkey: authen.getToken()
      })).then(res => {
        const data = unwrapResponse(res);
        if (data && data.ok) commit('SET_CONFIG', data);
        return data;
      });
    },
    SAVE_CONFIG ({ commit, state }, config) {
      return httpService.methods.$post('MqttIntegrationAPI/SaveConfig', JSON.stringify({
        tokenkey: authen.getToken(),
        version: state.version,
        config
      })).then(res => {
        const data = unwrapResponse(res);
        if (data && data.ok) {
          commit('SET_CONFIG', {
            config: data.config,
            version: data.version,
            statuses: []
          });
        }
        return data;
      });
    },
    TEST_BROKER (_, broker) {
      return httpService.methods.$post('MqttIntegrationAPI/TestBroker', JSON.stringify({
        tokenkey: authen.getToken(),
        broker
      })).then(res => unwrapResponse(res));
    },
    PREVIEW_MAPPING (_, payload) {
      return httpService.methods.$post('MqttIntegrationAPI/PreviewMapping', JSON.stringify({
        tokenkey: authen.getToken(),
        mapping: payload.mapping,
        sourceField: payload.sourceField,
        rawValue: payload.rawValue
      })).then(res => unwrapResponse(res));
    },
    FETCH_CLIENTS (_, payload) {
      return httpService.methods.$post('MqttIntegrationAPI/ListClients', JSON.stringify(Object.assign({
        tokenkey: authen.getToken()
      }, payload || {}))).then(res => unwrapResponse(res));
    },
    CREATE_CLIENT (_, client) {
      return httpService.methods.$post('MqttIntegrationAPI/CreateClient', JSON.stringify({
        tokenkey: authen.getToken(),
        client
      })).then(res => unwrapResponse(res));
    },
    ROTATE_CLIENT (_, payload) {
      return httpService.methods.$post('MqttIntegrationAPI/RotateClient', JSON.stringify({
        tokenkey: authen.getToken(),
        id: payload.id,
        client: { password: payload.password || '' }
      })).then(res => unwrapResponse(res));
    },
    DELETE_CLIENT (_, id) {
      return httpService.methods.$post('MqttIntegrationAPI/DeleteClient', JSON.stringify({
        tokenkey: authen.getToken(),
        id
      })).then(res => unwrapResponse(res));
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/mqttIntegration.js